<div class="d-flex flex-column gap-2" *transloco="let t; prefix: 'fuelLevel'">
  <h1>{{ t('lowFuelAlerts.title') }}</h1>
  <div class="low-fuel-levels container-fluid ">
    <div class="header">
      <div class="row">
        <div class="col-5 assets">{{ t('fuelLevels.table.assets') }}</div>
        <div class="col-2 fuel-level">{{ t('fuelLevels.table.fuelLevel') }}</div>
        <div class="col distance">{{ t('fuelLevels.table.distanceToEmpty') }}</div>
      </div>
    </div>

    <div class="body" *ngIf="!isLoading && !isFuelLevelLoading() && filteredFuelLevels.length > 0 && !hasError">
      <cdk-virtual-scroll-viewport itemSize="42" minBufferPx="210" maxBufferPx="420" class="viewport">
        <div *cdkVirtualFor="let item of filteredFuelLevels; let i = index;" (click)="process(item)"
          class="clickable row">
          <ng-container *ngIf="!item.isLoading">
            <div class="col-5 text-wrap">
              <strong class=" text-truncate" [ngbTooltip]="item.assetName" placement="top"
                container="body">{{item.assetName}}</strong>
            </div>
            <div class=" col-2 liter">
              <app-fuel-level-display [level]="item.fuelLevel" [threshold]="item.lowFuelLevelThreshold">
              </app-fuel-level-display>
            </div>
            <div class="col flex flex-row justify-content-between">
              <span>{{getDistanceToEmpty(item.distanceToEmpty)}}</span>
              <button class="d-none d-xxl-block" [ngbTooltip]="t('lowFuelAlerts.clickToSeeNotification')">
                <img src="assets/images-fuel/infoIcon.svg" alt="" *ngIf="!item.isLoading" />
              </button>
            </div>
          </ng-container>
          <div *ngIf="item.isLoading" class="d-flex justify-content-center w-100 h-100">
            <span class="spinner-border"></span>
          </div>
        </div>

      </cdk-virtual-scroll-viewport>
    </div>

    <div class="d-flex flex-column justify-content-center align-items-center h-100 w-100"
      *ngIf="!isLoading && !isFuelLevelLoading() && filteredFuelLevels.length === 0 && !hasError">
      <span>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path opacity="0.2"
            d="M22.2807 7.99278L10.2432 20.0303C10.1736 20.1 10.0909 20.1553 9.99983 20.1931C9.90878 20.2308 9.81118 20.2502 9.71262 20.2502C9.61406 20.2502 9.51646 20.2308 9.42542 20.1931C9.33437 20.1553 9.25165 20.1 9.182 20.0303L2.4695 13.2803C2.32895 13.1396 2.25 12.9489 2.25 12.7501C2.25 12.5513 2.32895 12.3606 2.4695 12.22L4.7195 9.96996C4.78915 9.90023 4.87187 9.84491 4.96292 9.80717C5.05396 9.76943 5.15156 9.75 5.25012 9.75C5.34868 9.75 5.44628 9.76943 5.53733 9.80717C5.62837 9.84491 5.71109 9.90023 5.78075 9.96996L9.2195 13.2812C9.28915 13.3509 9.37187 13.4063 9.46292 13.444C9.55396 13.4818 9.65156 13.5012 9.75012 13.5012C9.84868 13.5012 9.94628 13.4818 10.0373 13.444C10.1284 13.4063 10.2111 13.3509 10.2807 13.2812L18.9695 4.71996C19.0392 4.65023 19.1219 4.59491 19.2129 4.55717C19.304 4.51943 19.4016 4.5 19.5001 4.5C19.5987 4.5 19.6963 4.51943 19.7873 4.55717C19.8784 4.59491 19.9611 4.65023 20.0307 4.71996L22.2807 6.93246C22.4213 7.0731 22.5002 7.26379 22.5002 7.46262C22.5002 7.66145 22.4213 7.85214 22.2807 7.99278Z"
            fill="#9FA1A4" />
          <path
            d="M22.8073 6.39782L20.5573 4.18907C20.2761 3.90913 19.8956 3.75195 19.4988 3.75195C19.1021 3.75195 18.7215 3.90913 18.4404 4.18907L9.74977 12.7503L9.73946 12.74L6.30446 9.43345C6.02264 9.15453 5.64184 8.99855 5.24533 8.9996C4.84882 9.00066 4.46886 9.15866 4.18852 9.43907L1.93852 11.6891C1.65772 11.9703 1.5 12.3515 1.5 12.7489C1.5 13.1463 1.65772 13.5275 1.93852 13.8088L8.6529 20.5588C8.79219 20.6981 8.95756 20.8086 9.13958 20.884C9.32159 20.9594 9.51667 20.9982 9.71368 20.9982C9.91069 20.9982 10.1058 20.9594 10.2878 20.884C10.4698 20.8086 10.6352 20.6981 10.7745 20.5588L22.812 8.52314C22.9515 8.38347 23.0622 8.21761 23.1375 8.03509C23.2128 7.85257 23.2514 7.65697 23.251 7.45951C23.2505 7.26205 23.2111 7.06662 23.135 6.88443C23.0588 6.70224 22.9475 6.53688 22.8073 6.39782ZM9.71415 19.5003L2.99977 12.7503L5.24977 10.5003L5.26009 10.5106L8.69509 13.8172C8.97597 14.0954 9.35535 14.2515 9.75071 14.2515C10.1461 14.2515 10.5255 14.0954 10.8063 13.8172L19.5054 5.25032L21.7498 7.46282L9.71415 19.5003Z"
            fill="#9FA1A4" />
        </svg>
      </span>
      <span class="text-secondary fs-14 fw-bold">
        {{ t('lowFuelAlerts.noNotifications') }}
      </span>
    </div>

    <div class="d-flex flex-column justify-content-center align-items-center w-100 h-100"
      *ngIf="isLoading || isFuelLevelLoading()">
      <span class="spinner-border"></span>
    </div>

    <div class="d-flex flex-column justify-content-center align-items-center w-100 h-100"
      *ngIf="!isLoading && !isFuelLevelLoading() && hasError">
      <app-error-state></app-error-state>
    </div>
  </div>
</div>